import { ANALYZE_CHECKOUT_STEP_VIEW, ANALYZE_ORDER_CONFIRMATION_PAGE } from 'b2b-apps/shop/analytics/redux';

enum CHECKOUT_TYPE {
  guest = 'guest',
  login = 'w_login',
  req = 'w_req'
}

enum CHECKOUT_STEP {
  checkoutSignin = 'checkout_signin',
  checkoutRegister = 'checkout_register',
  checkoutAddress = 'checkout_address',
  checkoutDelivery = 'checkout_delivery',
  checkoutPayment = 'checkout_payment',
  checkoutOverview = 'checkout_overview',
  b2bCheckoutShippingAndPayment = 'checkout_shipping_and_payment',
  b2bCheckoutOverview = 'checkout_overview',
}


type AnalyzeCheckoutStepViewAction = {
  type: typeof ANALYZE_CHECKOUT_STEP_VIEW;
  payload: {
    step: CHECKOUT_STEP
  }
};

type AnalyzeOrderConfirmationPageAction = {
  type: typeof ANALYZE_ORDER_CONFIRMATION_PAGE;
  payload: {
    isCollectedOrder?: boolean;
  }
}


type CheckoutAnalyticsAction =
  | AnalyzeCheckoutStepViewAction
  | AnalyzeOrderConfirmationPageAction;

export {
  CHECKOUT_STEP,
  CHECKOUT_TYPE,
};

export type {
  AnalyzeCheckoutStepViewAction,
  AnalyzeOrderConfirmationPageAction,
  CheckoutAnalyticsAction,
};
